<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="dialog-attachment"
      id="bv-modal-select-attachment"
      :title="$tr('listOfAttachments','List of attachments')"
      @close="onHide"
      data-backdrop="static" data-keyboard="false"
      size="xl"
      ref="modal"
  >
    <b-container class="px-0 mx-0" fluid="true">
      <b-row>
        <b-col style="height: 500px">
          <DataGrid2
              data-test-path="attachment-grid"
              style="height: 100%"
              ref="grid"
              name="attachmentDialog"
              v-model="listOfSelectedAttachments"
              :selectedIndex.sync="selectedIndex"
              :items="listOfAttachmentsGrid"
              :columns="fields"
              :headerShowReload="false"
              searchBarClass="d-none d-md-block"
              select-mode="range"
              @rows-selected="onRowSelected"
              :details-enable="false"
              filtersColsClasses="col-xl-auto col-md-auto col"
          >
            <b-container v-if="!readOnly">
              <b-row>
                <div class="col" style="min-width: 80px">
                  <FileUpload
                      data-test-path="attachment-upload"
                      class="d-none d-md-block"
                      @file-selected="attachmentSelected"
                      ref="attachmentUpload"
                  >
                  </FileUpload>

                  <span class="d-block d-md-none" v-if="loading" style="width: 40px; padding-top: 5px">
                      {{ percentDone }} %
                    </span>
                  <b-button v-else
                            class="d-block d-md-none"
                            variant="plm-toolbar-secondary"
                            @click="uploadAttachment"
                  >
                    <font-awesome-icon icon="upload"/>
                  </b-button>
                </div>

                <b-col cols="auto" class="mr-auto">
                  <b-button
                      data-test-path="share-attachment"
                      :disabled="!listOfSelectedAttachments"
                      @click="shareAttachments"
                      class="d-none d-xl-block"
                      variant="plm-toolbar-secondary"
                  >
                    <font-awesome-icon class="ml-1" icon="share-alt"/>
                    Share
                  </b-button>
                  <b-button
                      data-test-path="share-attachment"
                      :disabled="!listOfSelectedAttachments"
                      @click="shareAttachments"
                      class="d-block d-xl-none"
                      variant="plm-toolbar-secondary"
                  >
                    <font-awesome-icon icon="share-alt"/>
                  </b-button>
                </b-col>

                <b-col cols="auto">
                  <b-button
                      v-if="numberOfSelectedRows > 1"
                      class="d-none d-xl-block button-long-delete"
                      variant="plm-toolbar-danger"
                      :disabled="!listOfSelectedAttachments"
                      @click="deleteAttachment"
                  >
                    <font-awesome-icon class="ml-1" icon="trash"/>
                    {{$tr('removeSelected','Remove selected')}}
                  </b-button>
                  <b-button
                      v-else
                      data-test-path="delete-attachments"
                      class="d-none d-xl-block"
                      variant="plm-toolbar-danger"
                      :disabled="!listOfSelectedAttachments"
                      @click="deleteAttachment"
                  >
                    <font-awesome-icon class="ml-1" icon="trash"/>
                    Remove
                  </b-button>
                  <b-button class="d-block d-xl-none"
                            data-test-path="delete-attachments"
                            variant="plm-toolbar-danger"
                            :disabled="!listOfSelectedAttachments"
                            @click="deleteAttachment"
                  >
                    <font-awesome-icon icon="trash"/>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </DataGrid2>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{close}" class="p-0">
      <FooterNavbar data-test-path="attachment-dialog-footer" class="w-100">
        <CloseButton :read-only="readOnly" @close="onHide"></CloseButton>
        <FooterButton
            v-if="readOnly"
            type="Edit"
            @edit="edit"
        >
        </FooterButton>
        <FooterButton
            v-if="!readOnly"
            type="Save"
            @save="onOk"
        >
        </FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import FileUpload from "@/components/FileUpload";
import IconAttachment from "@/components/datagrid/IconAttachment";
import DialogManager from "@/utils/DialogManager";
import AttachmentName from "@/components/datagrid/AttachmentName";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import {AttachmentDialogResult} from "@/components/dialogs/results/AttachmentDialogResult";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";

export default {
  name: "AttachmentDialog",
  components: {FooterButton, FileUpload, DataGrid2, VBox, FooterNavbar, CloseButton},

  created() {
    /** @type {Function} */
    this.attachmentLoad = null;
  },

  async beforeMount() {
  },

  mounted() {
    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs["grid"];

  },


  methods: {


    uploadAttachment() {
      this.$refs.attachmentUpload.$refs.fileInput.click();
    },

    async onOk() {
      if (this.resolve != null) {
        this.result = new AttachmentDialogResult();
        this.result.attachmentsList = this.listOfAttachmentsGrid;
        this.result.numberOfUnsavedAttachments = this.numberOfUnsavedAttachments;
        this.result.isSavedClicked = true;
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.result = new AttachmentDialogResult();
        this.result.attachmentsList = this.originalList;
        this.result.numberOfUnsavedAttachments = this.numberOfUnsavedAttachments;
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    reset() {
      this.result = null;
      this.resolve = null;
      this.readOnly = true;
    },

    edit() {
      this.readOnly = false;
    },

    async attachmentSelected() {
      if (this.attachmentLoad) {
        let attachmentUpload = this.$refs.attachmentUpload;
        let file = attachmentUpload.getFile();
        this.loading = true;
        attachmentUpload.setProgress(0);
        try {
          let attachment = await this.attachmentLoad(file).lock().onProgress((e) => {
            attachmentUpload.setProgress(e.percent);
            this.percentDone = Math.floor(e.percent);
          });
          if (attachment) {
            attachment.data.size = getFileSizeFormatter(attachment.data.size);
            this.listOfAttachmentsGrid.push(attachment);
            this.numberOfUnsavedAttachments++;
          }
          this.loading = false;
          attachmentUpload.reset();
        } catch (e) {
          this.loading = false;
          if (e instanceof RpcInputValidationException) {
            attachmentUpload.setError(e.fields.image.errorMessage);
          } else {
            throw e;
          }
        }
      }

    },

    onRowSelected(items) {
      this.numberOfSelectedRows = items.length;
    },


    async deleteAttachment() {
      let listOfSelectedAttachments = this.listOfSelectedAttachments;
      if (this.numberOfSelectedRows === 1) {
        if (await DialogManager.yesNo($tr('deletingAttachment','Deleting attachment') ,
            $tr('attachmentDialog.sure.delete','Are you sure you want to delete this attachment?'))) {
          await this.deleteAttachmentSubmit(listOfSelectedAttachments);
        }
      } else {
        if (await DialogManager.yesNo($tr('deletingSelectedAttachments','Deleting selected attachments'),
            $tr('attachmentDialog.sure.delete','Are you sure you want to delete this attachment?'))) {
          await this.deleteAttachmentSubmit(listOfSelectedAttachments);
        }
      }
    },

    async deleteAttachmentSubmit(listOfSelectedAttachments) {

      for (let i = 0; i < listOfSelectedAttachments.length; i++) {
        let originalResult = _.find(this.originalList, {token: listOfSelectedAttachments[i].token});
        let tempResult = _.find(this.listOfAttachmentsGrid, {token: listOfSelectedAttachments[i].token});
        if (originalResult) {
          this.numberOfUnsavedAttachments++;
        }
        if (!originalResult && tempResult) {
          this.numberOfUnsavedAttachments--;
        }
      }
      this.listOfAttachmentsGrid = _.difference(this.listOfAttachmentsGrid, listOfSelectedAttachments);
    },

    async shareAttachments() {
      await DialogManager.shareAttachmentDialog(this.listOfSelectedAttachments);
    }
  },

  data: () => ({
    listOfAttachmentsGrid: [],
    originalList: [],
    fields: [
      {
        name: '', size: 55, sortable: true,
        template: IconAttachment
      },
      {
        name: 'Name', size: 210, sortable: true,
        template: AttachmentName
      },
      {name: 'Size', sortable: true, size: 110, template: "<div>{{model.data.size}}</div>"},
      {name: 'Uploaded by', sortable: true, size: 210, template: "<div>{{model.data.uplBy}}</div>"},
    ],
    type: null,
    resolve: null,
    /** @type{AttachmentDialogResult} */
    result: null,
    listOfSelectedAttachments: null,
    selectedIndex: null,
    selectedAttachmentIndex: null,
    numberOfSelectedRows: 0,
    readOnly: true,
    numberOfUnsavedAttachments: null,
    loading: false,
    percentDone: 0,
    attachmentLoad: null,

  })
}
</script>
